export function checkPhone (value, rule) {  //电话校验
  const  required = rule.required || rule._required;
  const phoneReg = /^1[0-9]{10}$/;
  const telReg = /(^(\d{2,4}[-_－—]?)?\d{3,8}([-_－—]?\d{3,8})?([-_－—]?\d{1,7})?$)|(^0?1[35]\d{9}$)/;
  if(required) {  //必填
    if (!value) {
      return '手机号码不能为空'
    }
    if(phoneReg.test(value)) {
      return true
    } else {
      return '手机号码格式不正确'
    }
  } else {  //非必填
    if(value) {
      if(phoneReg.test(value)) {
        return true
      } else {
        return '手机号码格式不正确'
      }
    } else {
      return true
    }
  }
}

export function checkPassword (value, rule) { //密码校验
  const required = rule.required || rule._required;
  const mailReg = /^[^\s]{6,16}$/;
  if(required) {  //必填
    if (!value) {
      return '密码不能为空';
    }
    if(mailReg.test(value)) {
      return true
    } else {
      return '密码长度6-16位，不允许有空格'
    }
  } else {  //非必填
    if(value) {
      if(mailReg.test(value)) {
        return true
      } else {
        return '密码长度6-16位，不允许有空格'
      }
    } else {
      return true
    }
  }
}

export function checkTrainPhone (value, rule) {  //手机号+固定电话校验
  const  required = rule.required || rule._required;
  const phoneReg = /^((1[0-9]{10})|(([0-9]{3,4}-)?[0-9]{7,8}))$/;
  if(required) {  //必填
    if (!value) {
      return '手机号码不能为空';
    }
    if(phoneReg.test(value)) {
      return true
    } else {
      return '手机号码格式不正确(固话请加-)'
    }
  } else {  //非必填
    if(value) {
      if(phoneReg.test(value)) {
        return true
      } else {
        return '手机号码格式不正确(固话请加-)'
      }
    } else {
      return true
    }
  }
}

export function checkEmail (value, rule) { //邮箱校验
  const  required = rule.required || rule._required;
  const mailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  if(required) {  //必填
    if (!value) {
      return '邮箱不能为空';
    }
    if(mailReg.test(value)) {
      return true
    } else {
      return '请输入正确的邮箱格式'
    }
  } else {  //非必填
    if(value) {
      if(mailReg.test(value)) {
        return true
      } else {
        return '请输入正确的邮箱格式'
      }
    } else {
      return true
    }
  }
}


export function checkcertificateNum(value, rule) { //证书编号格式校验
  const required = rule.required || rule._required;
  const tarNum = /^(([0-9]{14}))$/;

  if (required) { //必填
    if (!value) {
      return '证书编号不能为空'
    }
    if (tarNum.test(value)){
      return true
    } else{
      return '请输入正确的证书编号格式'
    }
  } else {
    if (values) {
      if (tarNum.test(value)){
        return true
      } else{
        return '请输入正确的证书编号格式'
      }
    } else {
      return true
    }
  }
}

export function checkUserName (value, rule) {
  const required = rule.required || rule._required;
  const mailReg = /^[^\s@]{3,18}$/;
  const numReg = /^\d+$/;
  if (required) {  //必填
    if (!value) {
      return '账号不能为空'
    }
  } else {  //非必填
    if(!value) {
      return true
    }
  }
  if (value) {
    if (!mailReg.test(value)) {
      return '账号长度3-18位，不允许有@字符或空格或者纯数字'
    }
    if (numReg.test(value)) {
      return '账号组成不可为纯数字'
    }
  }
  let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if(iconRule2.test(value)){
    return "不能包含表情符号"
  }
  return true;
}

export function routePathHandler(routePath) {  //route路径处理
  if(routePath.charAt(routePath.length - 1) === '/') {
    routePath = routePath.slice(0, routePath.length - 1);
  }
  return routePath;
}

/**
 *
 * @param frameDom:显示区域对象
 * @param wrapDom:整个列表对象
 * @param itemNum:列表个数
 * @param screenWidth:屏幕宽度
 */
export function screenScrollHandler(frameId, wrapID, itemNum, screenWidth, callback, index=0) {
  let frameDom = document.getElementById(frameId)
  let wrapDom = document.getElementById(wrapID)
  let startX, startY, endX, endY, swipeLeft, swipeRight;

  wrapDom.showIndex = index;
  wrapDom.showFrameOffset = -(screenWidth * index)
  // wrapDom.style.transform = `translateX(${ wrapDom.showFrameOffset })`
  wrapDom.style.left = `${ wrapDom.showFrameOffset }`
  wrapDom.isTranslate = false
  wrapDom.itemNum = itemNum;

  if(frameDom.touchStartHandler && frameDom.touchMoveHandler && frameDom.touchEndHandler) {
    frameDom.removeEventListener('touchstart', frameDom.touchStartHandler)
    frameDom.removeEventListener('touchmove', frameDom.touchMoveHandler)
    frameDom.removeEventListener('touchend', frameDom.touchEndHandler)
  }

  frameDom.touchStartHandler = event => {
    startX = event.targetTouches[0].screenX;
    startY = event.targetTouches[0].screenY;
    swipeLeft = false, swipeRight = false;
  }
  frameDom.touchMoveHandler = event => {
    endX = event.targetTouches[0].screenX;
    endY = event.targetTouches[0].screenY;
    // 左右滑动
    if (Math.abs(endX - startX) - Math.abs(endY - startY) > 0) {
        event.preventDefault();
       // wrapDom.style.transform = `translateX(${wrapDom.showFrameOffset + endX - startX}px)`;
       wrapDom.style.left = `${wrapDom.showFrameOffset + endX - startX}px`;
        if (endX - startX > 0) {  //向右滑动
            swipeRight = true;
            swipeLeft = false;
        }
        else {  //向左滑动
            swipeLeft = true;
            swipeRight = false;
        }
    }
  }
  frameDom.touchEndHandler = () => {
    if (Math.abs(endX - startX) - Math.abs(endY - startY) > 0) {
      if (swipeRight) {
        swipeRight = !swipeRight;
        if(wrapDom.showIndex !== 0 && Math.abs(endX - startX) > screenWidth / 4) {  //向右滑动
          wrapDom.showIndex --;
          wrapDom.isTranslate = true;
        }
      }
      if(swipeLeft) {
        swipeLeft = !swipeLeft;
        if(wrapDom.showIndex !== (wrapDom.itemNum - 1) && Math.abs(endX - startX) > screenWidth / 4) {  //向左滑动
          wrapDom.showIndex ++;
          wrapDom.isTranslate = true;
        }
      }
      wrapDom.showFrameOffset = -(screenWidth * wrapDom.showIndex)
    }
    // wrapDom.style.transform = `translateX(${wrapDom.showFrameOffset}px)`
    wrapDom.style.left = `${wrapDom.showFrameOffset}px`;
    if(wrapDom.isTranslate) {
      // console.log('wrapDom.showIndex='+wrapDom.showIndex)
      wrapDom.isTranslate = false;
      callback(wrapDom.showIndex)
    }

  }

  frameDom.addEventListener('touchstart', frameDom.touchStartHandler, { passive: false })
  frameDom.addEventListener('touchmove', frameDom.touchMoveHandler, { passive: false })
  frameDom.addEventListener('touchend', frameDom.touchEndHandler, { passive: false })

}

export function checkTaxpayerNum(value, rule) { //纳税人识别号校验
  const required = rule.required || rule._required;
  const tarNum = /^(([0-9A-Z]{15})|([0-9A-Z]{18})|([0-9A-Z]{20}))$/;

  if (required) { //必填
    if (!value) {
      return '纳税人识别号不能为空'
    }else{
      if (!tarNum.test(value)) {
        return '请输入正确的纳税人识别号格式(无需加 - )'
      }
    }
  }
  if (value) {
    if (!tarNum.test(value)) {
      return '请输入正确的纳税人识别号格式'
    }
  }
  return true;

}

export function scrollToTop() {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}

export function checkIDCardNo(value, rule) { //身份证号校验
  const required = rule.required || rule._required;
  if (!value){
     return '身份证号不能为空'
  }
  if (value.length != 18){
    return '请输入正确的身份证号'
  }

  if (isNaN(value.slice(0,17))){
    return '请输入正确的身份证号'
  }

  if (Number(value.slice(6,10)) % 4 == 0 || (Number(value.slice(6,10)) % 100 == 0 && Number(value.slice(6,10)) % 4 == 0)){
      // # 出生日期闰年时合法性正则表达式
      var birthday = /^[1-9][0-9]{5}(19[0-9]{2}|20[0-9]{2})((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/
  }
  else{
      // # 出生日期平年时合法性正则表达式
      var birthday = /^[1-9][0-9]{5}(19[0-9]{2}|20[0-9]{2})((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/
  }
  if (!value.match(birthday)){
      callback(new Error('请输入正确的身份证号'))
  }

  var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
  var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
  var code = value.substring(17);

  if (required) { //必填
    if (!value) {
      return '身份证号不能为空'
    }

    if(birthday.test(value)) {
        var sum = 0;
        for(var i=0;i<17;i++) {
            sum += value[i]*factor[i];
        }
        if(parity[sum % 11] == code.toUpperCase()) {
            return true;
        }
    }
    return '请输入正确的身份证号'


  }

}
